<template>
    <Modal :title="today.title" v-model="today.show" draggable :mask-closable="false" width="600">
        <div style="font-size: 1.25em;max-height: 60vh;overflow: auto;">
            <div v-if="today.data.length == 0">暂无数据</div>
            <div v-for="(item, index) in today.data" :key="index">
                <!-- 正常 -->
                <div style="display:flex" v-if="!item.companyName">
                    <div class="title" style="font-weight:700">{{ item.index }} : </div>
                    <div class="value">
                        <a :href="`/chome/siteDetection?siteMn=${encodeURIComponent(item.mn)}&siteId=${encodeURIComponent(item.id)}`">
                            {{ item.name }}
                        </a>
                    </div>
                </div>
                <!-- 详细 -->
                <div style="display:flex"
                    v-if="item.companyName && (256 == (item.status & 256) || 64 == (item.status & 64) || 2 == (item.status & 2) || 8 == (item.status & 8))">
                    <div class="title" style="font-weight:700">{{ item.siteName }}：</div>
                    <div class="value"> {{ item.name }} 设备处于告警中</div>
                </div>
                <div style="display:flex" v-if="item.companyName && 16 == (item.status & 16)">
                    <div class="title" style="font-weight:700">{{ item.siteName }}：</div>
                    <div class="value">{{ item.name }} 设备处于预警中</div>
                </div>
                <!-- 详细 -->
                <div style="display:flex" v-if="item.status == 4">
                    <div class="title" style="font-weight:700">{{ item.name }}：</div>
                    <div class="value"> 停运</div>
                </div>
            </div>
        </div>
        <div slot="footer"></div>
    </Modal>
</template>

<script>
export default {
    data() {
        return {
            today: {
                title: null,
                show: false,
                data: []
            },
            countList: {}
        }
    },
    created() {
        //this.chartsInit3();
    },
    methods: {
        // 企业map转list
        mapToList(map) {
            let list = [];
            for (let item in map) {
                list.push({
                    name: item,
                    value: map[item]
                });
            }
            return list;
        },
        statistics(msg) {
            this.today.show = true;
            switch (msg) {
                // case "vent": {
                // this.today.data = this.mapToList(this.countList.allData);
                // this.today.title = "站点/装置详情";
                // break;
                // }
                case "vent": {
                    this.today.title = "站点/装置告警列表"; // 告警是2 预警16
                    this.$api.Enum.getSiteEnum({}, [
                        "uuid",
                        "company"
                    ]).then(res => {
                        if (res.code == 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                res.data[i].index = i + 1;
                            }
                            this.today.data = res.data;
                        }
                    });
                    break;
                }
                case "warn": {
                    // this.today.data = this.mapToList(this.countList.warnData);
                    this.today.title = "站点/装置告警列表"; // 告警是2 预警16
                    this.$api.Park.getWarnOrEasyDeils({ content: { state: "18" } }, [
                        "uuids",
                        "park"
                    ]).then(res => {
                        if (res.code == 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                // res.data[i].status = 18;
                            }
                            this.today.data = res.data;
                        }
                    });

                    break;
                }
                case "shut": {
                    // this.today.data = this.mapToList(this.countList.eWarnData);
                    this.today.title = "生产设施停运列表"; // 停机 4
                    this.$api.Park.getWarnOrEasyDeils({ content: { state: "4" } }, [
                        "uuids",
                        "park"
                    ]).then(res => {
                        if (res.code == 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                res.data[i].status = 4;
                            }
                            this.today.data = res.data;
                        }
                    });
                    break;
                }
            }
        },
        // chartsInit3() {
        //     this.getAccessWarnCount().then(res => {
        //         if (res.code == 0) {
        //             let data = res.data;
        //             this.countList.allData = data.ventCount;
        //             this.countList.eWarnData = data.earlyWarnCount;
        //             this.countList.warnData = data.deviceShutDownCount;
        //         }
        //     });
        // },
        // getAccessWarnCount() {
        //     return new Promise((resovle, reject) => {
        //         this.$api.Park.getAccessWarnCount(null, ["uuids", "park"]).then(res => {
        //         resovle(res);
        //         });
        //     });
        // }
    }
}
</script>

<style lang="scss" scoped></style>